import React from 'react';
import DataDiary, { DiaryRecord } from '../../../components/charts/DataDiary';
import styled from 'styled-components/native';
import { differenceInDays, format } from 'date-fns';
import { Platform, View } from 'react-native';
import Card from '../../../components/Card';

const StyledCard = styled(Card)`
  overflow: hidden;
  justify-content: center;
  ${Platform.OS === 'web' && 'align-self: center'};
`;

export type DataDiaryProps = {
  startDate?: Date;
  diaryRecord?: DiaryRecord;
};

const DataDiaryTabView: React.FC<DataDiaryProps> = ({
  startDate,
  diaryRecord
}) => {
  const dateToday = new Date(format(new Date(), 'MM/dd/yyyy'));
  const formattedStartDate = new Date(
    format(startDate || new Date(), 'MM/dd/yyyy')
  );
  const currentDay = differenceInDays(dateToday, formattedStartDate) + 1;
  return (
    <View>
      <StyledCard>
        {diaryRecord && (
          <DataDiary diaryData={diaryRecord} currentDay={currentDay} />
        )}
      </StyledCard>
    </View>
  );
};

export default DataDiaryTabView;
